import type { PdfEngine, PdfEngineOptions } from "@pdfking/pdfengine"

import fail from "../utils/fail"

export const EngineCache = {}

export const Engine: PdfEngine = {
  config: {} as PdfEngineOptions,
  SplitPdf: fail,
  RasterizePdf: fail,
  MergePdf: fail,
  ZipFiles: fail,
  PlotPdf: fail,
  DownloadFile: fail,
  CreateRemoteFile: fail,
  GenerateFile: fail,
  RequestBlob: fail,
}

export const CreateRemoteFile = fail
